import { render, staticRenderFns } from "./IncreaseLimit.vue?vue&type=template&id=83867802&"
import script from "./IncreaseLimit.vue?vue&type=script&lang=js&"
export * from "./IncreaseLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports